import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useExistingUserCheck } from '../../hooks/useExistingUserCheck/useExistingUserCheck';
import { useRecaptcha } from '../../hooks/useRecaptcha/useRecaptcha';
import { useGetProduct } from '../../hooks/useGetProduct/useGetProduct';
import {
  trackCheckoutStarting
} from '../emailPage/EmailPage';
import { EmailInputForm } from '../emailInputForm/EmailInputForm';
import { NewTrialAccountDetailsForm } from '../newTrialAccountDetailsForm/NewTrialAccountDetailsForm';
import { FEELIX_THEMES } from '../../constants';

export const getSubmitButtonTextOnAccountDetailsForm = (
  isNewUser: boolean,
  isSolo: boolean
): string => {
  if (isNewUser) {
    if (isSolo) {
      return 'Step 2: Create password';
    }
    return 'Next: Set my password';
  }
  return 'Sign in to create subscription';
};

export const NewTrialEmailPage: React.FC = () => {
  const [emailValue, setEmailValue] = useState('');
  const {
    region,
    setHasPurchaseSubmitted,
    theme,
    setEmailChecked
  } = useSessionContext();
  setHasPurchaseSubmitted(false);
  const { isLoading: isProductLoading, isSuccess: fetchProductDataSuccess, productData } = useGetProduct();
  const {
    isNewUser, isEmailChecked, isError, identityId
  } = useExistingUserCheck(emailValue);
  setEmailChecked && setEmailChecked(isEmailChecked);
  trackCheckoutStarting(isEmailChecked, emailValue); // This function contains React Hooks, never put it in a condition.
  const {
    isLoading: isRecaptchaLoading,
    success: isRecaptchaSuccess
  } = useRecaptcha({ enabled: isEmailChecked, action: 'view', identityId });

  const isLoading = isRecaptchaLoading || isProductLoading;
  if (isLoading) {
    return (<div data-testid='email-page-loading'/>);
  }
  const isProductAndRegionMatched: boolean = fetchProductDataSuccess && productData && region === productData.region;
  if (isRecaptchaSuccess === false || !isProductAndRegionMatched) {
    return <Redirect to='/error' />;
  }

  const isSolo = theme === FEELIX_THEMES.SOLO;
  if (isEmailChecked) {
    return (
      <React.Fragment>
        <NewTrialAccountDetailsForm
          submitButtonText={getSubmitButtonTextOnAccountDetailsForm(isNewUser, isSolo)}
          isNewUser={isNewUser}
          emailValue={emailValue}
        />
      </React.Fragment>
    );
  }
  return (
    <EmailInputForm
      onSubmit={setEmailValue}
      isError={isError}
    />
  );
};
